import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import type { ComponentType, ClassAttributes, HTMLAttributes } from 'react';

// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledRoot: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div({
	margin: 0,
	padding: `${token('space.200')} ${token('space.250')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledUnsupportedMacro: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	//eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > span': {
		verticalAlign: 'middle',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledHeader: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div({
	textAlign: 'center',
	display: 'block',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledFooter: ComponentType<
	ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
> = styled.div({
	marginTop: token('space.600'),
	textAlign: 'center',
	display: 'block',
});
